import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import JoinVodaPayClub from '../JoinVodaPayClub/JoinVodaPayClub.jsx';
import VodaPayClubPage from '../VodaPayClub/VodaPayClubPage.jsx';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';
import Loading from '../../components/Loading/Loading.jsx';
import { CategoriesContext } from '../../services/context/CategoriesContext.js';
import { allowedStatuses } from '../../services/Constants/config.js';

/**
 * Handles routing logic for VodapayClub page based on subscription status.
 *
 * @returns {JSX.Element} VodaPayClubRouter Component
 */
export default function VodaPayClubRouter() {
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const categories = useContext(CategoriesContext);
  const navigateTo = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const rawStatus = subscriptionDetails?.subscriptionStatus?.toLowerCase();
    const isCancelled = subscriptionDetails?.data?.isCancelled === true;
    const normalizedStatus = rawStatus || (isCancelled ? 'cancelled' : '');
    const allowedStatus = allowedStatuses.includes(subscriptionDetails?.status);

    // Handle API error
    if (subscriptionDetails.status && !allowedStatus) {
      setLoading(false);
      navigateTo(ROUTES.HOME);
      return;
    }

    // Wait until either status or cancellation info is available
    if (!rawStatus && !isCancelled) return;

    const validStatuses = [
      'active',
      'unsubscribed',
      'cancelled',
    ];
    const isValid = validStatuses.includes(normalizedStatus);

    if (!isValid) {
      navigateTo(ROUTES.HOME);
    }

    setLoading(false);
  }, [subscriptionDetails]);

  if (loading) {
    return <Loading headerText='Loading...' />;
  }

  const rawStatus = subscriptionDetails?.subscriptionStatus?.toLowerCase();
  const isCancelled = subscriptionDetails?.data?.isCancelled === true;
  const normalizedStatus = rawStatus || (isCancelled ? 'cancelled' : '');

  if (normalizedStatus === 'unsubscribed') {
    return <JoinVodaPayClub />;
  }

  if (normalizedStatus === 'active' || (normalizedStatus === 'cancelled' && categories.length > 0)) {
    return <VodaPayClubPage />;
  }
}
